import React, { Component, Fragment } from "react";

export default class NomeUnidade extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Footer"
        }
    }

    render() {
        return (
            <Fragment>
                <nav className="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent">
                    <div className="container-fluid">
                        <div className="navbar-wrapper">
                            <div className="navbar-toggle">
                                <button type="button" className="navbar-toggler">
                                    <span className="navbar-toggler-bar bar1"></span>
                                    <span className="navbar-toggler-bar bar2"></span>
                                    <span className="navbar-toggler-bar bar3"></span>
                                </button>
                            </div>
                            <a className="navbar-brand text-uppercase" href="#">{this.props.unidade}</a>
                        </div>
                    </div>
                </nav>
            </Fragment>
        )
    }
}



